import { render, staticRenderFns } from "./classification-native.vue?vue&type=template&id=96e32ec4"
import script from "./classification-native.vue?vue&type=script&lang=js"
export * from "./classification-native.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports